<template>
  <div>
    <header-component></header-component>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Credit Notes List</h3>
        </div>
        <el-table
          :data="creditNoteList"
          class="table-responsive table-flush sales-table"
          header-row-class-name="thead-light"
        >
          <el-table-column label="Customer Name"  min-width="60px">
            <template slot-scope="scope">{{scope.row.user.firstName +' '+ scope.row.user.lastName}}</template>
          </el-table-column>
          <el-table-column label="Date"  min-width="60px">
             <template slot-scope="scope">{{ scope.row.date | convertDate }}</template>
          </el-table-column>
          <el-table-column label="Invoice Number" prop="invoiceNumber" min-width="60px"></el-table-column>
           <el-table-column label="Payment Mode"  min-width="60px"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>


<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { format } from "date-fns";
import headerComponent from "../Components/HeaderComponent";

export default {
  filters: {
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    }
  },
  data: () => {
    return {
      creditNote:{}
    };
  },

  computed: {
    ...mapGetters({
      creditNoteList: "creditNote/getCreditNoteList"
    })
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    // "show-bill": showBill,
    "header-component": headerComponent
  },

  mounted() {
    this.getCreditNotes();
  },

  methods: {
    ...mapActions({ getCreditNotes: "creditNote/getCreditNotes" })
  }
};
</script>



<style lang="scss">
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.sales-table {
  .el-table__row {
    text-transform: capitalize;
  }
}
</style>